import { render, staticRenderFns } from "./BetgameAccessibility.vue?vue&type=template&id=354c6444&scoped=true"
import script from "./BetgameAccessibility.vue?vue&type=script&lang=js"
export * from "./BetgameAccessibility.vue?vue&type=script&lang=js"
import style0 from "./BetgameAccessibility.vue?vue&type=style&index=0&id=354c6444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354c6444",
  null
  
)

export default component.exports